module.exports = __webpack_public_path__ + "img/dispatchsijitouxiang.a401c6f3.png";